import {
  ApiRoute,
  CreateOrgReview,
  OrgFullDetail,
  OrgFullDetailSchema,
  OrgMemberDetail,
  OrgMemberDetailSchema,
  OrgMemberRole,
  OrgPublicDetail,
  OrgPublicDetailSchema,
  OrgReview,
  OrgReviewDetail,
  OrgReviewDetailSchema,
  OrgReviewSchema,
  UpdateOrg,
  getApiRoute
} from "@garther/interfaces";
import { z } from "zod";

import { API_BASE_URL } from "../configs";
import { BaseApiClient } from "./base-client";

class OrgApiClient extends BaseApiClient {
  constructor() {
    super({
      baseURL: API_BASE_URL,
      baseEndpoint: getApiRoute(ApiRoute.ORG),
      requireAuth: true
    });
  }

  async getListByUserId(userId: string): Promise<OrgMemberDetail[]> {
    return await this.get(`/user/${userId}`, z.array(OrgMemberDetailSchema), { requireAuth: true });
  }

  async getOne(orgId: string): Promise<OrgPublicDetail | null> {
    try {
      return await this.get(orgId, OrgPublicDetailSchema, { requireAuth: false });
    } catch (error) {
      return null;
    }
  }

  async getFullDetail(orgId: string): Promise<OrgFullDetail | null> {
    try {
      return await this.get(`${orgId}/full`, OrgFullDetailSchema, { requireAuth: false });
    } catch (error) {
      return null;
    }
  }

  async getReviews(orgId: string): Promise<OrgReviewDetail[]> {
    return await this.get(`${orgId}/reviews`, z.array(OrgReviewDetailSchema), {
      requireAuth: false
    });
  }

  async createReview(orgId: string, data: CreateOrgReview): Promise<OrgReview> {
    return await this.post(`${orgId}/reviews`, OrgReviewSchema, data, { requireAuth: true });
  }

  async update(orgId: string, data: UpdateOrg): Promise<OrgFullDetail> {
    return await this.patch(orgId, OrgFullDetailSchema, data, { requireAuth: true });
  }

  async updateMemberRole(orgId: string, data: { userId: string; role: OrgMemberRole }): Promise<void> {
    return await this.post(`${orgId}/members`, z.void(), data, { requireAuth: true });
  }
}

export const orgApiClient = new OrgApiClient();
